import { Alert } from 'antd';
import { Component } from 'react';

import s from './Error.module.scss';

class Error extends Component {
	render() {
		const { text, status, onErrorClose, close } = this.props;

		return (
			<div className={s.error}>
				<Alert message={status} description={text} type="error" showIcon closable={close} onClose={() => onErrorClose()} />
			</div>
		);
	}
}

export default Error;
